import React from 'react'
import firstBlog from '../img/latest-new/o-1.jpg'
import secondBlog from '../img/latest-new/o-2.jpg'

const Blog = () => {
	return (
		<>
			<section className="section p-t-100 p-b-65" id="about-banner">
				<div className="container">
					<div className="page-heading">
						<h4 className="about_t">Our Blog</h4>
					</div>
				</div>
			</section>

			<section className="our-blog">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="f-blog-img">
								<div className="blog-img">
									<img src={firstBlog} alt="First Blog" />
								</div>
								<div className="why">
									<h2>Why do we keep building glass skyscrapers?</h2>
								</div>
							</div>
							<div id="t-scroll">
								<p>
									Despite criticisms about their environmental impact, glazed
									skyscrapers continue to spring up in cities around the world.
									Jon Astbury investigates why they remain so popular. In 2011,
									British architect Ken Shuttleworth – who designed the Gherkin
									while at Foster + Partners – declared that "the tall glass box
									is dead". He doubled down a few years later, telling the BBC:
									"We can't have those all-glass buildings. We need to be much
									more responsible." Speaking to CNN in 2018, he described a
									"sea change in attitudes" towards the typology. "We created
									too many large expanses of glass" Shuttleworth's is not a
									fringe view. In 2021, Morphosis partner Ung-Joo Scott Lee and
									Kohn Pedersen Fox president James von Klemperer also predicted
									the demise of the glazed tower in interviews with Dezeen. "I
									think we all feel, as a community of architects, that we all
									created and had built too many large expanses of glass in our
									cities," said Von Klemperer. For their proponents, glass
									skyscrapers remain one of the most powerful and economically
									attractive ways of staking a claim on a city and skyline. But
									for their critics, they are gleaming symbols of all that is
									wrong with modern architecture and construction, representing
									the maximising of real estate regardless of how
									energy-guzzling or visually homogenous the results may be.
								</p>
								<p>
									As pressure to decarbonise the built environment intensifies,
									the scrutiny is only growing. Studies have shown that the
									environmental performance of glass buildings simply does not
									stack up. Nowhere in the world does it make practical sense to
									cover a building entirely in glass – they require air
									conditioning in summer and leak heat in winter. "There's
									strong evidence we are over-glazing our buildings," said
									Phillip Oldfield, head of the school of the built environment
									at UNSW Sydney and author of The Sustainable Tall Building: A
									Design Primer. "Most towers probably have a window to wall
									ratio of 50 to 80 per cent. Research suggests in office
									buildings in Europe, the optimal ratio is closer to 30 to 45
									per cent – but this should differ on each facade," he told
									Dezeen. "The trend, rather than being dead, is accelerating"
									In spite of all of this, the sea change predicted by
									Shuttleworth, Scott Lee, Von Klemperer and others is yet to
									happen. In some places, the trend seems to point in the
									opposite direction. A quick glance at the Council on Tall
									Buildings and Urban Habitat's list of the 100 tallest
									buildings under construction shows that most are all-glass,
									steel and concrete-framed skyscrapers, regardless of
									geographic location.
								</p>
								<p>
									Even in New York City, where in 2019 then-mayor Bill de Blasio
									said that glass skyscrapers "have no place in our city or our
									Earth anymore", proposals for such buildings continue to
									emerge – including a design for a 487-metre-tall tower on Park
									Avenue by architecture studio Foster + Partners, unveiled in
									September. "I think the trend, rather than being dead, is
									accelerating for two reasons," said Oldfield. "One: glass
									curtain walling is incredibly successful as a building
									product. It combines all the basic performance requirements of
									the building skin (acoustic, thermal, solar, visual, et
									cetera) into one comprehensive product that can be quickly
									lifted on site and fitted into place – so it's an efficient
									and economical solution." Now, a widening gap exists between
									some architects and their clients. For example, Robert
									Greenwood, a director at Snøhetta, is unequivocal about the
									Norwegian architecture studio's view. "For our part, we do
									declare once again that the all-glass skyscraper is finally
									dead," he told Dezeen. "Commercially driven, this
									objectification of architecture seeks to celebrate what the
									building is, rather than what it does." "Most locations will
									demand more of the building than that it stands alone as a
									reflective tower, glazed equally on all facades."
									Nevertheless, Snøhetta still works on skyscraper projects that
									are predominantly glass, as do Morphosis and KPF.
								</p>
								<p>
									New materials and technologies New technologies that improve
									the thermal efficiency of glass curtain walling are
									continuously emerging, and proponents argue they see off the
									worst criticisms about unsustainability. Indeed, Mies van der
									Rohe himself predicted the necessity of these developments,
									saying of his modernist glass boxes that it was "up to the
									engineers to find some way to stop the heat from coming in or
									going out. "Technologically, recent improvements in glass
									systems have greatly reduced energy use, through an optimised
									approach to heating and cooling," Pelli Clarke &amp; Partners
									partner Darin Cook told Dezeen. The US architecture studio
									continues to build numerous all-glass skyscrapers worldwide,
									recently completing the Salesforce Tower in Chicago, but now
									tends to incorporate special coatings in the facade that
									reduce heat gain or integrate solar panels. The most advanced
									glazed curtain walls are now composed of up to four layers of
									glass, such as Zaha Hadid Architects' glass skyscraper on what
									is reportedly the world's most expensive plot in Hong Kong,
									featuring four-ply, double-laminated, double-curved insulated
									glass panels. But Oldfield has his doubts about this technical
									solutionism. "My big criticism is we seem to be adding more
									materials and technologies to solve a problem that could
									easily be solved by simply using less glass," he said.
									Additionally, while the advancement of glass panel systems
									helps to reduce carbon impact during the building's
									operational lifespan, these benefits can be outweighed by
									being far more carbon-intensive to create and more difficult
									to recycle. "In practice, the recycling and re-use of complex
									flat-glass facade components is notoriously difficult," said
									Greenwood. "Today almost all glass materials removed from
									glazed cladding systems are typically downcycled or
									landfilled." Mordak echoes these concerns. "To create
									buildings according to circular economy principles, things
									need to be made with reclaimed and recycled materials as much
									as possible, be repairable, and also be demountable and
									recyclable at the end of their lives," they explained. "This
									can be more challenging when tall buildings need to be so
									highly engineered as to require very high-performance
									materials." While glass itself is considered to have a service
									life of 60 years and up, the insulated panels common in
									curtain walling are thought to last between 25 and 35 years.
									Upgrading these systems is possible. In the refurbishment of 1
									Triton Square in London, for example, facade suppliers
									Scheldebouw removed the original glass curtain wall panels,
									refurbished and reinstalled them. But as hundreds of tall
									glazed buildings reach "retrofit age", Oldfield is doubtful
									about whether this will be most developers' preferred option.
									"Around the world there are some 944 office buildings more
									than 100 metres tall that were completed between 1953 and
									1983, and are probably in danger of demolition," he said.
									"That's millions of tonnes of embodied carbon at risk." Some
									architects do appear to be having success in convincing
									developers to go for a more contextual alternative to the
									all-glazed facade. In particular, the US has seen a recent
									shift back towards the more solid facades that defined the
									earliest high-rises. And even long-time designers of glass
									skyscrapers such as Pelli Clarke &amp; Partners acknowledge
									the role of better suiting climates and conditions. "While
									glass-clad towers will likely remain a staple of architectural
									design, designers are increasingly leveraging new materials
									and systems to better suit local climates and conditions, and
									in many cases, reducing the surface amount of glass and
									incorporating alternative materials," said Cook. Detractors of
									the glazed curtain wall may view that as a small but hopeful
									sign of progress – but while the glass skyscraper might be
									dead in the minds of architects, for the many others who shape
									our cities it remains alive and well.
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="our-blog">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="f-blog-img">
								<div className="blog-img">
									<img src={secondBlog} alt="First Blog" />
								</div>
								<div className="why">
									<h2>
										The Future of Sustainable Architecture: Trends and
										Innovations What is Sustainable Architecture?
									</h2>
								</div>
							</div>
							<div id="t-scroll">
								<p>
									Despite criticisms about their environmental impact, glazed
									skyscrapers continue to spring up in cities around the world.
									Jon Astbury investigates why they remain so popular. In 2011,
									British architect Ken Shuttleworth – who designed the Gherkin
									while at Foster + Partners – declared that "the tall glass box
									is dead". He doubled down a few years later, telling the BBC:
									"We can't have those all-glass buildings. We need to be much
									more responsible." Speaking to CNN in 2018, he described a
									"sea change in attitudes" towards the typology. "We created
									too many large expanses of glass" Shuttleworth's is not a
									fringe view. In 2021, Morphosis partner Ung-Joo Scott Lee and
									Kohn Pedersen Fox president James von Klemperer also predicted
									the demise of the glazed tower in interviews with Dezeen. "I
									think we all feel, as a community of architects, that we all
									created and had built too many large expanses of glass in our
									cities," said Von Klemperer. For their proponents, glass
									skyscrapers remain one of the most powerful and economically
									attractive ways of staking a claim on a city and skyline. But
									for their critics, they are gleaming symbols of all that is
									wrong with modern architecture and construction, representing
									the maximising of real estate regardless of how
									energy-guzzling or visually homogenous the results may be.
								</p>
								<p>
									As pressure to decarbonise the built environment intensifies,
									the scrutiny is only growing. Studies have shown that the
									environmental performance of glass buildings simply does not
									stack up. Nowhere in the world does it make practical sense to
									cover a building entirely in glass – they require air
									conditioning in summer and leak heat in winter. "There's
									strong evidence we are over-glazing our buildings," said
									Phillip Oldfield, head of the school of the built environment
									at UNSW Sydney and author of The Sustainable Tall Building: A
									Design Primer. "Most towers probably have a window to wall
									ratio of 50 to 80 per cent. Research suggests in office
									buildings in Europe, the optimal ratio is closer to 30 to 45
									per cent – but this should differ on each facade," he told
									Dezeen. "The trend, rather than being dead, is accelerating"
									In spite of all of this, the sea change predicted by
									Shuttleworth, Scott Lee, Von Klemperer and others is yet to
									happen. In some places, the trend seems to point in the
									opposite direction. A quick glance at the Council on Tall
									Buildings and Urban Habitat's list of the 100 tallest
									buildings under construction shows that most are all-glass,
									steel and concrete-framed skyscrapers, regardless of
									geographic location.
								</p>
								<p>
									Even in New York City, where in 2019 then-mayor Bill de Blasio
									said that glass skyscrapers "have no place in our city or our
									Earth anymore", proposals for such buildings continue to
									emerge – including a design for a 487-metre-tall tower on Park
									Avenue by architecture studio Foster + Partners, unveiled in
									September. "I think the trend, rather than being dead, is
									accelerating for two reasons," said Oldfield. "One: glass
									curtain walling is incredibly successful as a building
									product. It combines all the basic performance requirements of
									the building skin (acoustic, thermal, solar, visual, et
									cetera) into one comprehensive product that can be quickly
									lifted on site and fitted into place – so it's an efficient
									and economical solution." Now, a widening gap exists between
									some architects and their clients. For example, Robert
									Greenwood, a director at Snøhetta, is unequivocal about the
									Norwegian architecture studio's view. "For our part, we do
									declare once again that the all-glass skyscraper is finally
									dead," he told Dezeen. "Commercially driven, this
									objectification of architecture seeks to celebrate what the
									building is, rather than what it does." "Most locations will
									demand more of the building than that it stands alone as a
									reflective tower, glazed equally on all facades."
									Nevertheless, Snøhetta still works on skyscraper projects that
									are predominantly glass, as do Morphosis and KPF.
								</p>
								<p>
									New materials and technologies New technologies that improve
									the thermal efficiency of glass curtain walling are
									continuously emerging, and proponents argue they see off the
									worst criticisms about unsustainability. Indeed, Mies van der
									Rohe himself predicted the necessity of these developments,
									saying of his modernist glass boxes that it was "up to the
									engineers to find some way to stop the heat from coming in or
									going out. "Technologically, recent improvements in glass
									systems have greatly reduced energy use, through an optimised
									approach to heating and cooling," Pelli Clarke & Partners
									partner Darin Cook told Dezeen. The US architecture studio
									continues to build numerous all-glass skyscrapers worldwide,
									recently completing the Salesforce Tower in Chicago, but now
									tends to incorporate special coatings in the facade that
									reduce heat gain or integrate solar panels. The most advanced
									glazed curtain walls are now composed of up to four layers of
									glass, such as Zaha Hadid Architects' glass skyscraper on what
									is reportedly the world's most expensive plot in Hong Kong,
									featuring four-ply, double-laminated, double-curved insulated
									glass panels. But Oldfield has his doubts about this technical
									solutionism. "My big criticism is we seem to be adding more
									materials and technologies to solve a problem that could
									easily be solved by simply using less glass," he said.
									Additionally, while the advancement of glass panel systems
									helps to reduce carbon impact during the building's
									operational lifespan, these benefits can be outweighed by
									being far more carbon-intensive to create and more difficult
									to recycle. "In practice, the recycling and re-use of complex
									flat-glass facade components is notoriously difficult," said
									Greenwood. "Today almost all glass materials removed from
									glazed cladding systems are typically downcycled or
									landfilled." Mordak echoes these concerns. "To create
									buildings according to circular economy principles, things
									need to be made with reclaimed and recycled materials as much
									as possible, be repairable, and also be demountable and
									recyclable at the end of their lives," they explained. "This
									can be more challenging when tall buildings need to be so
									highly engineered as to require very high-performance
									materials." While glass itself is considered to have a service
									life of 60 years and up, the insulated panels common in
									curtain walling are thought to last between 25 and 35 years.
									Upgrading these systems is possible. In the refurbishment of 1
									Triton Square in London, for example, facade suppliers
									Scheldebouw removed the original glass curtain wall panels,
									refurbished and reinstalled them. But as hundreds of tall
									glazed buildings reach "retrofit age", Oldfield is doubtful
									about whether this will be most developers' preferred option.
									"Around the world there are some 944 office buildings more
									than 100 metres tall that were completed between 1953 and
									1983, and are probably in danger of demolition," he said.
									"That's millions of tonnes of embodied carbon at risk." Some
									architects do appear to be having success in convincing
									developers to go for a more contextual alternative to the
									all-glazed facade. In particular, the US has seen a recent
									shift back towards the more solid facades that defined the
									earliest high-rises. And even long-time designers of glass
									skyscrapers such as Pelli Clarke & Partners acknowledge the
									role of better suiting climates and conditions. "While
									glass-clad towers will likely remain a staple of architectural
									design, designers are increasingly leveraging new materials
									and systems to better suit local climates and conditions, and
									in many cases, reducing the surface amount of glass and
									incorporating alternative materials," said Cook. Detractors of
									the glazed curtain wall may view that as a small but hopeful
									sign of progress – but while the glass skyscraper might be
									dead in the minds of architects, for the many others who shape
									our cities it remains alive and well.
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default Blog